import React, { createContext, useState, useEffect, useContext } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";
import { refreshFcmToken } from "firebase-helper";
import { usersAPI } from "../services/api"; // API importunu unutma!

const AuthContext = React.createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const response = await axios.get(`${API_BASE_URL}/me`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setUser(response.data.user);

          // Adam giriş yaptığında sessizce token kontrolü yap
          const fcmToken = await refreshFcmToken();
          if (fcmToken) {
            try {
              // Eğer token döndüyse (veya değiştiyse) backend'e yaz
              await usersAPI.storeFcmToken(fcmToken, navigator.userAgent);
              console.log("FCM Token backend ile senkronize edildi.");
            } catch (e) {
              console.warn("FCM Token senkronizasyon hatası:", e.message);
            }
          }
        } catch (error) {
          console.error("Token'la kullanıcı bilgisi alınamadı.", error);
          localStorage.removeItem("token");
          setUser(null);
        }
      }
      setLoading(false);
    };

    fetchUser();
  }, []);

  const login = async (userData, token) => {
    localStorage.setItem("token", token);
    setUser(userData);

    // Landing Page'den gelen park edilmiş token varsa backend'e yolla
    const pendingFcmToken = localStorage.getItem("pending_fcm_token");
    if (pendingFcmToken) {
      try {
        await usersAPI.storeFcmToken(pendingFcmToken, navigator.userAgent);
        console.log("Misafirken alınan FCM Token backend'e eşleştirildi.");
        localStorage.removeItem("pending_fcm_token");
      } catch (err) {
        console.error("Park edilmiş FCM token gönderilirken hata:", err);
      }
    } else {
      // Park edilmiş token yoksa, güncel token'ı sessizce alıp yolla
      const currentToken = await refreshFcmToken();
      if (currentToken) {
        try {
          await usersAPI.storeFcmToken(currentToken, navigator.userAgent);
        } catch (e) {
          console.warn("Sessiz token gönderim hatası", e.message);
        }
      }
    }
  };

  const logout = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        await axios.post(
          `${API_BASE_URL}/logout`,
          {},
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      } catch (error) {
        console.error("Logout sırasında hata:", error);
      }
    }
    localStorage.removeItem("token");
    setUser(null);
  };
  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return React.useContext(AuthContext);
};
